module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div>\n    Your new Foxx Service is ready for download.\n    You can edit it on your local system and repack it in a zip file to publish it on ArangoDB.\n  </div>\n';
}
return __p;
};
